@if (label(); as label) {
  <label [attr.for]="id() || uuid" class="text-xs font-medium text-foreground-primary-60">{{ label }}</label>
}

<label [attr.for]="id() || uuid" class="flex relative rounded-radius-tertiary">
  @if (checked() || indeterminate()) {
    <svg-icon
      [key]="indeterminate() ? 'indeterminate-16' : 'check-16'"
      [size]="size() === '24' ? '24' : '16'"
      class="absolute w-full h-full top-0 left-0 pointer-events-none text-foreground-secondary-100"
    ></svg-icon>
  }

  <input
    [attr.id]="id() || uuid"
    type="checkbox"
    [checked]="checked()"
    [disabled]="disabled() || readonly()"
    (change)="onCheckboxChange($event)"
    (blur)="onBlur()"
    class="determinate cursor-pointer appearance-none rounded-radius-tertiary text-action-primary"
    [ngClass]="{
      'w-4 h-4': size() === '16',
      'w-6 h-6': size() === '24',
      'border border-stroke-action bg-foreground-secondary-100': !checked() && !indeterminate(),
      'bg-action-primary': checked() || indeterminate(),
    }"
  />
</label>
